import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    HUB_PAGE_LOADING() {
      return {
        isLoading: true,
        hubPage: {}
      };
    },
    HUB_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const tag = get(action, 'hubPage.tag', {});
      const supertags = get(currentState, 'supertags.supertags', {});
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        tag,
        'tagPage',
        supertags
      );
      return {
        isLoading: false,
        data: action.hubPage,
        ads: adModelData
      };
    },
    HUB_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.hubPage.errorMessage,
        hubPage: {}
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
